const initialState = {
  isFetching: false,
  isFetchingExpandedData: false,
  isFetchingVulnDetails: false,
  error: false,
  errorMessage: '',
  vulnsList: [],
  vulnsSelected: [],
  vulnsCount: 0,
  showDeleteConfirmation: false,
  showLeftFilters: false,
  showVulnDetail: false,
  vulnDetail: undefined,
  bulkUpdateField: '',
  bulkUpdateValue: '',
  lastSelected: -1,
  lastIndexForRange: -1,
  usesMockVulns: false,
  vulnDetailSelectedTab: 'general',
  showContextMenu: false,
  contextMenuXPos: 0,
  contextMenuYPos: 0,
  templatesCreated: [],
  failedTemplates: [],
  imagePreview: '',
  selectAll: false
};

export default initialState;
